import React from "react";
import { List, Avatar, Modal, Divider, Tree, Dropdown, Tooltip } from "antd";
import { AppstoreFilled } from "@ant-design/icons";
// import { useContext } from "react";
// import SystemContext from "./contextAPI/SystemContext";
import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import { Button, Col, Row } from "reactstrap";
import GatewayIcon from "./gateway.png"
import OptimizerIcon from "./optimizer.png"
import "./style.css"
// import _ from "lodash";
// import { remove } from "lodash";

import { ExclamationCircleOutlined } from "@ant-design/icons";
import { add_system, reset_system } from "../../Redux/actions";
import { warning, error, success } from "../../Controllers/toast";
import { gql, useMutation, useQuery } from "@apollo/client";
import BlockGroupsComponent from "./blockGroupsComponent";

const { confirm } = Modal;
const { DirectoryTree } = Tree;

const GET_PLANT_DEVICES = gql`
  query ($plant_id: Int!) {
    GetPlantDevices(plant_id: $plant_id) {
        Gateway_id
        serial_number
        batch_number
        Optimizer_Group {
          PO_id
          serial_number
          batch_number
        }
        blockgroups {
            Block_Group_Info {
                block_name
                id
            }
            Block_Group_id
            Opt_Group_id
        }
    }
  }
`;
const DELETE_GATEWAY = gql`
  mutation($Gateway_id: Int!, $plant_id: Int!){
    UnAssignGateway(Gateway_id: $Gateway_id, plant_id: $plant_id) {
        Gateway_id
        serial_number
        batch_number
        Optimizer_Group {
          PO_id
          serial_number
          batch_number
        }
      }
  }
`
const CHANGE_BLOCK_NAME = gql`
  mutation ChangeBlockName($Opt_Group_id: Int!,$block_name: String,$Block_Group_id:Int!,$Block_Name_Id:Int) {
    ChangeBlockName(Opt_Group_id:$Opt_Group_id,block_name:$block_name,Block_Group_id:$Block_Group_id,Block_Name_Id:$Block_Name_Id) {
      Block_Group_Info { 
        id
        block_name
      }
    }
  }
    `

const TreeListSystem = (props) => {
    const [blockNameId, setBlockNameId] = useState(0)
    const [name, setName] = useState("")
    const [optGroupId, setOptGroupId] = useState()
    const [blkGroupId, setBlkGroupId] = useState()
    const [visible, setVisible] = useState(false)

    const new_system = useSelector((state) => state.add_system);
    const dispatch = useDispatch();

    // console.log(props, "is props")

    useEffect(() => {
        if (props.counter > 0) {
            refetch({ plant_id: props.plant_id })
            props.setCounter(0)
        }
    }, [props.counter])

    const [data, setData] = useState([])
    const { loading, error: plantGetError, refetch } = useQuery(GET_PLANT_DEVICES, {
        variables: { plant_id: props.plant_id },
        onCompleted: (res) => {
            // console.log(res.GetPlantDevices)
            setData(res.GetPlantDevices)

        },
        onError: (err) => {
            // console.log(err);
            error("مشکلی در دریافت اطلاعات رخ داده است!")
        }
    });
    const [deleteGateway] = useMutation(DELETE_GATEWAY, {
        onCompleted: (res) => {
            // console.log(res);
            setData(res.UnAssignGateway)
            warning(
                `دستگاه با موفقیت حذف شد!`
            );
            window.location.reload()
        },
        onError: (err) => {
            // console.log(err);
            error("مشکلی در حذف دستگاه رخ داده است!")
        }
    })

    const [changeBlockName] = useMutation(
        CHANGE_BLOCK_NAME,
        {
            onCompleted: (data) => {
                console.log(data)
                success("نام بلوک با موفقیت تغییر کرد!")
                setVisible(false)
            },
            onError: (err) => {
                // console.log(err.message);
                error(err.message);
            },
        }
    );
    // console.log(data, "is data");

    const onSelect = (keys, info) => {
        // console.log('Trigger Select', keys, info);
    };
    const onExpand = (keys, info) => {
        // console.log('Trigger Expand', keys, info);
    };


    const showDeleteConfirm = (item) => {
        confirm({
            title: "آیا از حذف دستگاه خود مطمئن هستید؟",
            icon: <ExclamationCircleOutlined />,
            content:
                "در صورتی که دستگاهی را حذف کنید می توانید دوباره آن را اضافه کنید.",
            okText: "حذف",
            okType: "danger",
            cancelText: "بازگشت",
            style: { zIndex: 100 },
            onOk() {
                // console.log("OK" , e , item);
                deleteGateway({
                    variables: {
                        Gateway_id: item.Gateway_id,
                        plant_id: props.plant_id
                    }
                })

            },
            onCancel() {
                // console.log("Cancel");
            },
        });
    };


    const handleOk = () => {
        changeBlockName({
            variables: {
                Opt_Group_id: optGroupId,
                Block_Name_Id: blockNameId,
                Block_Group_id: blkGroupId
            }
        })
        props.setCounter(1)
    }
    const handleCancel = () => {
        setVisible(false)
    }


    return (<div>
        <Modal
            title={"تغییر اطلاعات"}
            open={visible}
            onOk={handleOk}
            onCancel={handleCancel}
            afterClose={() => props.setCounter(1)}
            // okButtonProps={{ disabled: checkStatus(listData?.status).bool }}
            okText={"تغییر"}
            cancelText={"بازگشت"}
        >
            <div>
                <p>تغییر نام بلوک:</p>
                <BlockGroupsComponent Block_Group_id={blkGroupId} Opt_Group_id={optGroupId} activeId={blockNameId} setBlockName={(name) => setName(name)} setBlockNameId={id => setBlockNameId(id)} plantId={props.plant_id} />
            </div>
        </Modal>
        {loading ? (<p>در حال بارگذاری...</p>) : (
            <DirectoryTree
                onSelect={onSelect}
                onExpand={onExpand}
                treeData={data.map(item => ({
                    title: <Tooltip color="white" trigger="click"
                        title={(
                            <div className="menu" style={{ width: "150px", textAlign: "center" }} >
                                <ul style={{ padding: 0, listStyle: "none" }}>
                                    <p className="text-black">B/N: {item.batch_number}</p>
                                    <p className="text-black">S/N: {item.serial_number}</p>
                                    <Divider style={{ margin: '4px 0' }} />
                                    <li className="text-danger b-1" onClick={() => showDeleteConfirm(item)}>حذف</li>
                                    <Divider style={{ margin: '2px 0' }} />
                                    <li className="text-primary" onClick={() => {
                                        // console.log(item.blockgroups.Block_Group_Info.id)
                                        setVisible(true)
                                        setBlockNameId(item.blockgroups.Block_Group_Info.id)
                                        setOptGroupId(item.blockgroups.Opt_Group_id)
                                        setBlkGroupId(item.blockgroups.Block_Group_id)
                                    }}>تغییر</li>
                                </ul>
                            </div>
                        )}>
                        <span>{item.serial_number}</span>
                    </Tooltip>,
                    key: `${item.Gateway_id}-Gateway`,
                    icon: <img width={18} src={GatewayIcon} />,
                    children: item.Optimizer_Group.map(obj => ({
                        title: <Tooltip color="white" trigger="click"
                            title={(
                                <div className="menu" style={{ width: "150px", textAlign: "center" }} >
                                    <ul style={{ padding: 0, listStyle: "none" }}>
                                        <p className="text-black">B/N: {obj.batch_number}</p>
                                        <p className="text-black">S/N: {obj.serial_number}</p>
                                        <Divider style={{ margin: '4px 0' }} />
                                        {/* <li className="text-danger b-1">حذف</li>
                                        <Divider style={{ margin: '2px 0' }} /> */}
                                        <li className="text-primary">تغییر</li>
                                    </ul>
                                </div>
                            )}>
                            <span>{obj.serial_number}</span>
                        </Tooltip>,
                        key: `${obj.PO_id}-Optimizer`,
                        icon: <img width={18} src={OptimizerIcon} />,
                        isLeaf: true,
                    }))
                }))}
            />
        )}
    </div>
    );
};
export default TreeListSystem;
